import React from 'react'
import { connect } from 'react-redux'

import { dismissMessage } from '../actions'

import ErrorMessages from './ErrorMessages'

const mapStateToProps = state => ({
  messages: state.ui.messages
});

const mapDispatchToProps = dispatch => ({
  onDismiss: (id) => dispatch(dismissMessage(id))
})

const ErrorMessagesContainer = connect(mapStateToProps, mapDispatchToProps)(ErrorMessages)

export default ErrorMessagesContainer


// WEBPACK FOOTER //
// ./src/Components/checkout/components/ErrorMessagesContainer.js